import { DSText, DSTextInput } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { OrderNumberProps } from './type'

export const OrderNumber = ({ methods, accountKey }: OrderNumberProps) => {
  return (
    <>
      <Controller
        key={accountKey}
        name='numeroPedidoOperadora'
        control={methods.control}
        rules={{}}
        render={({ field: { onChange, value } }) => (
          <DSTextInput
            value={value}
            onChange={option => {
              onChange(option)
            }}
            label='Número do pedido na operadora'
            maxLength={50}
          />
        )}
      />
      {typeof methods.formState.errors.numeroPedidoOperadora?.message ===
        'string' && (
        <DSText as='span' size='sm' weight='semibold' color='errorLight'>
          {methods.formState.errors.numeroPedidoOperadora.message}
        </DSText>
      )}
    </>
  )
}
